/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    global: {
        '*': {
            WebkitTapHighlightColor: 'transparent'
        },
        'html, body': {
            backgroundColor: 'white',
            color: 'black'
        },
        body: {
            minHeight: '100vh'
        },
        '.react-target': {
            display: 'flex',
            minHeight: '100vh'
        },
        '*[role="button"]': {
            _focusVisible: {
                outline: 0,
                boxShadow: 'var(--chakra-shadows-outline)'
            }
        }
    }
}
